import { Bell } from 'lucide-react';
import { Badge, Button, useOverlayState } from '@heroui/react';
import { useQuery } from '@tanstack/react-query';
import { getUnreadCount, notificationsKeys } from '../../../api/notifications';
import { NotificationsDrawer } from './notifications-drawer';

export function NotificationsMenu() {
  const drawerState = useOverlayState();
  const unreadQuery = useQuery({
    queryKey: notificationsKeys.unreadCount(),
    queryFn: getUnreadCount,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });

  const unreadCount = unreadQuery.data ?? 0;
  const badgeLabel = unreadCount > 99 ? '99+' : String(unreadCount);
  const ariaLabel =
    unreadCount > 0
      ? `Notificações, ${unreadCount} não lidas`
      : 'Notificações';

  return (
    <>
      <Badge.Anchor>
        <Button
          isIconOnly
          variant="ghost"
          aria-label={ariaLabel}
          onPress={drawerState.open}
          data-tour="topbar-notifications"
        >
          <Bell size={20} />
        </Button>
        {unreadCount > 0 ? (
          <Badge size="sm" color="danger" variant="primary" placement="top-right">
            {badgeLabel}
          </Badge>
        ) : null}
      </Badge.Anchor>
      <NotificationsDrawer state={drawerState} />
    </>
  );
}
